import { css, styled } from "styled-components";
import {
  Popover as PopoverPrimitive,
  Dialog as DialogPrimitive,
  Button as ButtonPrimitive,
} from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import { Container as TooltipV2Container } from "../TooltipV2/TooltipV2.styled";

export const Popover = styled(PopoverPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { tooltip } = tokens;

    return css`
      z-index: ${tooltip.zIndex} !important;
    `;
  }}
`;

export const Dialog = styled(DialogPrimitive)`
  outline: none;
`;

export const Container = styled(TooltipV2Container)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { tooltip } = tokens;

    return css`
      padding-right: ${tooltip.padding.right.large};
    `;
  }}
`;

export const CloseButton = styled(ButtonPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { tooltip } = tokens;

    return css`
      all: unset;
      position: absolute;
      top: 0;
      right: 0;
      display: grid;
      place-items: center;
      width: ${tooltip.closeButton.width};
      height: ${tooltip.closeButton.height};
      cursor: pointer;

      svg {
        display: block;
        width: ${tooltip.closeButton.icon.width};
        height: ${tooltip.closeButton.icon.height};
        color: ${tooltip.closeButton.icon.color.base};
        background: ${tooltip.closeButton.icon.backgroundColor.base};
        border-radius: ${tooltip.closeButton.icon.radius};
      }

      &[data-hovered] {
        svg {
          color: ${tooltip.closeButton.icon.color.hover};
          background: ${tooltip.closeButton.icon.backgroundColor.hover};
        }
      }

      &[data-pressed] {
        svg {
          color: ${tooltip.closeButton.icon.color.active};
          background: ${tooltip.closeButton.icon.backgroundColor.active};
        }
      }

      &[data-focus-visible] {
        svg {
          outline-width: ${tooltip.closeButton.icon.focusRing.width};
          outline-style: ${tooltip.closeButton.icon.focusRing.style};
          outline-color: ${tooltip.closeButton.icon.focusRing.color};
        }
      }
    `;
  }}
`;
